import { navigate } from '@reach/router';
import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import { RouteComponentProps } from '../../../helpers/RouteComponentProps';
import { PageContainer } from '../../../layout/Layout';
import { PrimaryButton } from '../../../shared/Button';
import { Header1 } from '../../../shared/Headers';
import { MenuButton, MenuButtonItem } from '../../../shared/MenuButton';
import { colourNeutral07 } from '../../../styling/colours';
import { fontSize04 } from '../../../styling/fonts';
import { spacing02, spacing05, spacing06 } from '../../../styling/spacing';
import { HandoverPackSectionContext } from '../documents-section/HandoverPackSectionContext';
import { createHandoverPackSectionUrl, documentsRoot, getUpdateSectionUrl } from '../documents-section/documentRoutes';

type HandoverPackSectionListComponent = (props: RouteComponentProps) => JSX.Element | null;

export const HandoverPackSectionList: HandoverPackSectionListComponent = () => {
  const { handoverPackSections } = useContext(HandoverPackSectionContext);

  return (
    <PageContainer>
      <HeaderRow>
        <Header1>Handover Pack Section Configuration</Header1>
        <ButtonRow>
          <PrimaryButton onClick={() => navigate(documentsRoot)}>Manage Documents</PrimaryButton>
          <PrimaryButton onClick={() => navigate(createHandoverPackSectionUrl)}>Create New Section</PrimaryButton>
        </ButtonRow>
      </HeaderRow>
      {handoverPackSections.length === 0 ? (
        <p>No handover pack sections found</p>
      ) : (
        handoverPackSections.map(section => (
          <SectionContainer key={section.handoverPackSectionId}>
            <p>{section.sectionSequence}</p>
            <p>{section.sectionName}</p>
            <MenuButton>
              <MenuButtonItem onClick={() => navigate(getUpdateSectionUrl(section.handoverPackSectionId))}>
                Edit
              </MenuButtonItem>
            </MenuButton>
          </SectionContainer>
        ))
      )}
    </PageContainer>
  );
};

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${spacing05};
`;

const SectionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  border-radius: 5px;
  background-color: ${colourNeutral07};
  padding-left: ${spacing06};
  margin-top: ${spacing02};
  font-size: ${fontSize04};
`;

const ButtonRow = styled.div`
  display: flex;
  width: fit-content;
  gap: ${spacing02};
`;
